import { render } from "./ResetPassword.vue?vue&type=template&id=3c9820ce"
import script from "./ResetPassword.vue?vue&type=script&lang=js"
export * from "./ResetPassword.vue?vue&type=script&lang=js"
script.render = render

export default script